import React from "react";

const PendingResultMatch = ({ item }) => {
  return (
    <tr>
      <td className="bold">{"M" + item.mnum}</td>
      <td>{item.teamA}</td>
      <td>&nbsp;</td>
      <td className="righttext">{item.teamB}</td>
    </tr>
  );
};

export default PendingResultMatch;
